<template>
	<div
		class="flex gap-6 p-6 bg-white border border-gray-200 rounded-lg shadow-sm"
	>
		<!-- Icon -->
		<div
			class="flex items-center justify-center flex-shrink-0 bg-gray-100 rounded-lg w-11 h-11"
		>
			<Component
				:is="iconComponent"
				:size="20"
				class="text-neutral-800"
			/>
		</div>
		<div class="flex flex-col gap-[6px]">
			<h5 class="mb-0 text-base font-normal">
				{{ heading }}
			</h5>
			<p class="mb-0 text-sm">
				{{ content }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HowToUseBox',
	props: {
		iconComponent: {
			type: [Object, Function, String],
			required: true
		},
		heading: {
			type: String,
			required: true
		},
		content: {
			type: String,
			required: true
		}
	}
}
</script>
